import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
// import { Link } from 'react-router';
import { Loading } from 'components';
import { Helmet } from 'react-helmet';

// import { menus } from 'constants/menu';
// import loadingConstant from 'constants/loading';
import cn from 'classnames';
// import { Sider } from Layout;
import _ from 'lodash';

import enUS from 'antd/lib/locale-provider/en_US';
import moment from 'moment';
import config from './config';
import classes from './App.module.scss';
// import { addMessage, addNotification } from 'redux/modules/chat';
// const { Sider, Header, Content, Footer } = Layout;
// const SubMenu = Menu.SubMenu;

class App extends Component {
  constructor() {
    super();

    this.state = {
      collapsed: false,
    };
    moment.locale('th');
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  renderFullScreeenLoading() {
    let isShowLoading = false;
    // let isShowLoading = true;
    _.forEach(this.props.state, (store) => {
      const waitingObjects = _.pickBy(store, (value, key) => _.includes(key, 'waiting') || _.includes(key, 'Waiting'));
      // _.forEach(waitingObjects, (waitingValue, waitingKey) => {
      //   if (waitingValue === true && !_.includes(loadingConstant.ignore, waitingKey)) {
      //     isShowLoading = true;
      //     // waitingName = waitingKey;
      //   }
      // });
    });
    if (!isShowLoading) {
      return <div />;
    }
    return (
      <div>
        <div style={{ zIndex: 2100 }} className={cn(classes.loadingContainer, classes.fullScreenLoadingContainer)}>
          <div className={classes.containerBackground} />
          <Loading className={classes.loadingIndicatorFullScreen} />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={classes.app}>
        <Helmet />
        <div>
          {this.renderFullScreeenLoading()}
          {this.props.children}
        </div>
      </div>
    );
  }
}

// import React from "react";
// import logo from "./logo.svg";
// import "./App.css";

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default ;

export default connect(
  (state) => ({
    user: ((state || {}).auth || {}).user,
    state,
  }),
  {},
)(App);
